import React from 'react';

import FluxoImportacaoPlanoContextProvider from './FluxoImportacaoPlanoContextProvider';

const ImportPlanoModal = ({ descricao, id }) => <FluxoImportacaoPlanoContextProvider {...{ descricao, id }} />;

export default ImportPlanoModal;
